import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About'
import StudyTable from "./views/StudyTable";
import StudyResult from "./views/StudyResult";
import ExpTable from "./views/ExpTable";
import ExpResult from "./views/ExpResult";
import ContigTable from "./views/ContigTable";
import ContigResult from "./views/ContigResult";
import PepResult from "./views/PepResult";
import PepTable from "./views/PepTable";
import Blast from "./views/Blast";
import SearchPage from "./views/SearchPage";


Vue.use(Router);

export default new Router({
    mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
      {
          path: '/blast',
          name: 'Blast page',
          component: Blast
      },


      {
          path: '/about',
          name: 'About',
          component: About
      },
    {
      path: '/study',
      name: 'table/study',
        component: StudyTable
    },
      {
          path: '/study/:id',
          name: 'result/study',
          component: StudyResult
      },
      {
          path: '/exp',
          name: 'table/exp',
          component: ExpTable
      },
      {
          path: '/exp/:id',
          name: 'result/exp',
          component: ExpResult
      },
      {
          path: '/contig',
          name: 'table/contig',
          component: ContigTable
      },
      {
          path: '/contig/:id',
          name: 'result/contig',
          component: ContigResult
      },
      {
          path: '/protein',
          name: 'table/protein',
          component: PepTable
      },
      {
          path: '/protein/:id',
          name: 'result/protein',
          component: PepResult
      },
      {
          path: '/search',
          name: 'search_page',
          component: SearchPage
      }
  ]
})
